import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import UserService from "../../../services/user/UserService";
import { formatDateStringLocalDateINA, getNamaUPTBaru } from "../../../utilities/Utils";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textcenter: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign: "center"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const CetakSTLabnll = ({ dataDisposisi, datappm }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let userService = useMemo(() => new UserService(), [])
    const [uraianUpt, setUraianUpt] = useState(null)
    const [alamatUpt, setAlamatUpt] = useState(null)
    const [kotaUpt, setKotaUpt] = useState(null)
    const [dataPetugas, setDataPetugas] = useState(null)
    const [dataDetil, setDataDetil] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }
        try {
            const resUpt = await userService.getUptById(datappm.kodeUpt)
            setUraianUpt(getNamaUPTBaru(dataDisposisi.tglTugas, resUpt.data))
            setAlamatUpt(resUpt.data.alamatUnit)
            setKotaUpt(resUpt.data.kota)

            const resPetugas = await nonLalinService.listNonlalinPenugasanDetil(datappm.nomorAju, dataDisposisi.noTugas)
            setDataPetugas(resPetugas.data)

            const resDataDetil = await nonLalinService.listNonlalinDtlComplete(datappm.nomorAju)
            setDataDetil(resDataDetil.data.data)

        } catch (error) {

        }

    }, [dataDisposisi, datappm, userService, nonLalinService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '75%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>{uraianUpt}</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>{alamatUpt}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>SURAT PERINTAH PEMERIKSAAN LABORATORIUM</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>No. {dataDisposisi?.noTugas}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepada :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    {
                        dataPetugas && dataPetugas.map((ptg, idx) => {
                            return <View key={idx} style={[styles.tableRow, { marginBottom: 10 }]}>
                                <View style={[styles.tableCol, { width: '3%' }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{idx + 1}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '96%' }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{ptg.namaPetugas}/ {ptg.nipPetugas}</Text>
                                </View>
                            </View>
                        })
                    }
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Bahwa berdasarkan permohonan dari :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>a.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.namaTrader}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>b.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.alamatTrader}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>c.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nomor Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.nomorAju}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>d.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm ? formatDateStringLocalDateINA(datappm.tanggalAju) : null}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepada Saudara ditugaskan untuk melakukan pemeriksaan secara laboratoris terhadap produk perikanan sebagai berikut :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableCer3}>
                    <View style={[styles.tableRow, { borderTop: 1 }]}>
                        <View style={[styles.tableCol, { width: "3%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={styles.textcenter}>No.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Nama Sampel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Kondisi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Bentuk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Rekomendasi Pengujian</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Jumlah Pengujian</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "11%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Populasi</Text>
                        </View>
                    </View>
                    {
                        dataDetil && dataDetil.map((dtl, idx) => {
                            return <>
                                <View key={idx} style={[styles.tableRow, { borderTop: 1 }]}>
                                    <View style={[styles.tableCol, { width: "3%", borderRightWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{idx + 1}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.namaLokal}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.kondisi}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.bentuk}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.jenisPengujian}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.volume}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "11%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.populasi}</Text>
                                    </View>
                                </View>
                            </>
                        })
                    }
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Demikian agar dilaksanakan dengan penuh tanggung jawab.</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{kotaUpt}, {dataDisposisi ? formatDateStringLocalDateINA(dataDisposisi.tglTugas) : null}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala {uraianUpt},</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '60%', marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataDisposisi?.nmPejabat}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default CetakSTLabnll